import { navigateTo } from '#imports'

import { useHttpFetch } from '@backmarket/nuxt-module-http-v2/useHttpFetch'

import type {
  OrderlineOpenTask,
  OrderlineRequest,
} from '~/api/seller-after-sales/types'
import { ROUTE_NAMES } from '~/constants/routes'

export async function fetchAndGoToNextTask(taskId?: string) {
  if (!taskId) return

  const $httpFetch = useHttpFetch()

  const { resolutionId, orderlinePublicId } = await $httpFetch(
    '/seller-after-sales/api/v1/tasks/:taskId/next',
    {
      pathParams: { taskId },
    },
  )

  if (orderlinePublicId) {
    await navigateTo({
      name: ROUTE_NAMES.CUSTOMER_CARE.REQUEST,
      params: { orderlinePublicId },
    })

    return
  }

  if (resolutionId) {
    await navigateTo({
      name: ROUTE_NAMES.CUSTOMER_CARE.REQUEST_RESOLUTION,
      params: { resolutionId },
    })

    return
  }

  await navigateTo({
    name: ROUTE_NAMES.CUSTOMER_CARE.OPEN_TASKS,
    query: { taskCompleted: 'true' },
  })
}

export function getAllTasks(
  orderlineRequests: OrderlineRequest[],
): OrderlineOpenTask[] {
  return orderlineRequests.reduce(
    (allTasks: OrderlineOpenTask[], request) => [
      ...allTasks,
      ...request.openTasks,
    ],
    [],
  )
}

export function getMostUrgentTask(
  requests: OrderlineRequest[],
  resolutionId: string | null,
): OrderlineOpenTask | undefined {
  const requestsForCurrentResolutionId = requests.filter(
    (request) => request.resolutionId === resolutionId,
  )

  // Gets task with of requests with the current resolutionId in priority to avoid looping over the same tasks
  const allTasks = getAllTasks(
    requestsForCurrentResolutionId.length
      ? requestsForCurrentResolutionId
      : requests,
  )

  const openTasks = allTasks.filter((task) => task.status === 'OPEN')
  const orderedTask = openTasks.sort(
    (a, b) => Date.parse(a.deadline) - Date.parse(b.deadline),
  )

  return orderedTask[0]
}
